export const ALL_UUID = '00000000-0000-0000-0000-000000000000';

export const TRIAL_FOLLOW_UP_DAYS = [14, 7, 2, -7];

export const YEAR_END_MIN_DATE = new Date(2000, 0, 1);
export const YEAR_END_MAX_DATE = new Date(2000, 11, 31);

export const FONT_FAMILY = 'Inter, sans-serif';

export const IMAGE_UPLOAD_MAX_SIZE_KB = 200;
export const IMAGE_UPLOAD_ACCEPT = ['.png', '.jpg', '.jpeg'];

export const DOCUMENT_UPLOAD_MAX_SIZE_MB = 25;
export const DOCUMENT_DOWNLOAD_MAX_SIZE_MB = 25;

export const DOWNLOAD_REQUEST_APPROVAL_WORDING = 'I have reviewed and approve all files attached to this request.';
export const DOWNLOAD_REQUEST_REJECTION_REASON_MAX_LENGTH = 2000;

export const SIGN_REQUEST_MAX_FILES = 25;

export const DOCUMENT_BULK_DOWNLOAD_MAX_FILES = 50;
export const DOCUMENT_BULK_DOWNLOAD_MAX_SIZE_MB = 200;

export const IMPORT_LIMIT = 1000;

export const EXPORT_IN_PROGRESS_MESSAGE = `Export in progress - you'll receive a download link via email shortly`;

export const GDPR_HARD_DELETE_DAYS = 1;
